/**
 * The batched catalog-layers query key, in a leaf module of its own.
 *
 * It lives here rather than beside the hook because both directions need it: the
 * provider that READS it (`useProductCatalogLayers.tsx`) and the four layer
 * mutation families that must INVALIDATE it (`usePackagings`, `useDimensions`,
 * `useConfigurations`, `useProducts`' variant CRUD). Putting it in the hook file
 * would make `useProducts` import the module that imports it.
 *
 * **Nested under the `products` head on purpose.** React Query invalidates by key
 * PREFIX, so `invalidateQueries({ queryKey: productKeys.all })` — which every
 * product create / update / delete / bulk / quick-create already issues — reaches
 * the batched cache for free. The narrower per-layer keys
 * (`productKeys.variants(id)`, `packagingKeys.byProduct(id)`, …) do NOT share a
 * prefix with it, so those seams invalidate this key explicitly; that is the
 * obligation a new layer mutation inherits. `productKeys.all[0]` is asserted equal
 * to `all[0]` in `ProductReferencePicker.requestFanOut.test.tsx` so the nesting
 * cannot drift apart from the head it is pinned to.
 */
export const productCatalogLayerKeys = {
  all: ['products', 'catalog-layers'] as const,
  byProducts: (productIds: string[]) =>
    [...productCatalogLayerKeys.all, productIds] as const,
};
